// extracted by mini-css-extract-plugin
export default {"root":"_2RsF5","profile":"_314eg","cashback":"_2mWCe","userPhone":"_1onET"};